import { createWebSocketStore } from 'src/services/api/reallis/helpers';
export const getFilterActions = createWebSocketStore({
    auth: true,
    requestTemplate: {
        agent: 'admin',
        auth: { type: 'webSite' },
        lang: 'en',
        method: 'action_getAllByFilterList',
    },
    getResult(value) {
        return Object.assign(Object.assign({}, value), { data: value.data.map(o => (Object.assign(Object.assign({}, o), { createdAt: new Date(o.createdAt), updatedAt: new Date(o.updatedAt) }))) });
    },
});
export const undoActions = createWebSocketStore({
    auth: true,
    requestTemplate: {
        agent: 'admin',
        auth: { type: 'webSite' },
        lang: 'en',
        method: 'action_undo',
    },
});
